var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-button element-round-button",class:{ loading: _vm.loading }},[_c('div',{staticClass:"body"},[_vm._t("default")],2),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})])
}]

export { render, staticRenderFns }